import ApiV1, { GetApiV1Url } from "@/configs/axios/ApiV1";
import Axios from "@/configs/axios/Axios";
import PermissionsV1 from "@/router/permissions/v1";
import { HasPermissionOrThrow } from "@/utils/permisshoinHelper";

export function GetAttestationRoutes() {
  HasPermissionOrThrow(PermissionsV1["ATTESTATION.ROUTES"]);
  return Axios.get(GetApiV1Url(`attestations/routes/attestation`));
}

export function GetAttestationPersons(params) {
  // HasPermissionOrThrow(PermissionsV1['ATTESTATION.ROUTES'])
  return ApiV1.get(`attestations/persons`, { params });
}
